import { render, staticRenderFns } from "./morningTask.vue?vue&type=template&id=2fd5cba6&"
import script from "./morningTask.vue?vue&type=script&lang=js&"
export * from "./morningTask.vue?vue&type=script&lang=js&"
import style0 from "./morningTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "morningTask.vue"
export default component.exports